import { useCallback, useEffect, useState } from 'react'

import { api } from 'app/api'
import { GET_FOOD_SUPPLIERS, convertResult, convertParams } from 'app/common/api/requests/cabinet/compensation/food_suppliers/get'
import { FoodSuppliers } from 'app/dataTypes/cafeteria/compensation/foodSuppliers'


type Options = {
  studentID: string
}

export function useFoodSuppliers({ studentID }: Options) {
  const [foodSuppliers, setFoodSuppliers] = useState<FoodSuppliers>([])
  const [loading, setLoading] = useState(true)

  const request = useCallback(async () => {
    setLoading(true)
    const res = await api.request(GET_FOOD_SUPPLIERS, {
      error: 'Не удалось получить список поставщиков',
      params: {
        studentID,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    })

    setLoading(false)
    if (res) {
      setFoodSuppliers(res)
    }
  }, [studentID])

  useEffect(() => {
    request()
  }, [request, studentID])


  return {
    foodSuppliers,
    loading,
  }
}
